import {IFilterFunction} from "angular";
import {OrderViewModel} from "../models/OrderViewModel";
import {OrderStatus} from "../models/OrderRecord";

export const OrderModelStatus = "tfOrderModelStatus";

export function orderModelStatus(): IFilterFunction {
    return (model: OrderViewModel | null) => {
        if (model == null) {
            return null;
        }
        switch (model.status) {
            case OrderStatus.WAITING_OPERATOR:
                return "Waiting Operator";
            case OrderStatus.ON_MARKET:
                return "Working";
            case OrderStatus.DONE: {
                if (model.remainingQuantity === 0) {
                    return "Filled";
                } else if (model.isCancelled) {
                    return "Cancelled";
                } else {
                    return "Done";
                }
            }
        }
    };
}
